import * as React from 'react';
import { Query } from 'react-apollo';

import type { ApolloError } from 'apollo-client';

import s12nAccomplishmentsPageQuery from 'bundles/accomplishments/queries/S12nAccomplishmentsPageQuery.graphql';
import type {
  S12nAccomplishmentsPageQuery as S12nAccomplishmentsPageQueryResponse,
  S12nAccomplishmentsPageQueryVariables,
} from 'bundles/accomplishments/queries/__generated__/S12nAccomplishmentsPageQuery';

type ProductMetricState = {
  loading: boolean;
  error?: ApolloError;
  enrollmentCount?: number;
  learningMonths?: number | null;
  learningHoursPerWeek?: number | null;
};

type Props = {
  slug: string;
  children: (data: ProductMetricState) => JSX.Element;
};

const S12nAccomplishmentsDataProvider = ({ slug, children }: Props) => {
  return (
    <Query<S12nAccomplishmentsPageQueryResponse, S12nAccomplishmentsPageQueryVariables>
      query={s12nAccomplishmentsPageQuery}
      variables={{ slug }}
      context={{ clientName: 'gatewayGql' }}
    >
      {({ loading, error, data }) => {
        const totalEnrollmentCount = data?.DescriptionPage?.querySpecializationPage?.totalEnrollmentCount || 0;
        const totalLearningMonths = data?.DescriptionPage?.querySpecializationPage?.totalLearningMonths;
        const totalLearningHoursPerWeek = data?.DescriptionPage?.querySpecializationPage?.learningHoursPerWeek;
        return children({
          loading,
          error,
          enrollmentCount: totalEnrollmentCount,
          learningMonths: totalLearningMonths,
          learningHoursPerWeek: totalLearningHoursPerWeek,
        });
      }}
    </Query>
  );
};

export default S12nAccomplishmentsDataProvider;
